module.exports = __webpack_public_path__ + "img/light4.2f530893.png";